import { Component } from '@angular/core';

import { RendererBaseComponent } from 'sc-common';
import { ExternalEnumTagComponent } from 'sc-external/shared/components/enum-tag/enum-tag.component';

@Component({
    templateUrl: './enum-tag-renderer.component.html',
    imports: [ExternalEnumTagComponent]
})
export class EnumTagRendererComponent extends RendererBaseComponent {

    public enumType: any;

    public get columnEnumType(): any {

        if (this.enumType) {
            return this.enumType;
        }

        if (this.tableColumn.enumMap) {
            return this.tableColumn.dataType;
        }

        return null;
    }

    constructor() {
        super();
    }
}
